import i18next from 'i18next';
export var formatTableHeaderReport = function (title) {
    if (title === 'Average') {
        // Return "Average" for Average column
        return i18next.t('translation:table.average');
    }
    if (title === 'Total') {
        // Return "Total" for Total column
        return i18next.t('translation:table.total');
    }
    return title;
};
